import React from 'react'
import PageBanner from "app/components/ui/PageBanner"
import SiteGrid from "app/components/ui/SiteGrid"
import './styles/FaqsPage.css'
import { faqsArray } from "app/data/faqsData"
import { useState } from "react"
import HelmetTitle from "app/meta/HelmetTitle"
import faqsImg from 'app/assets/images/faqs-img.jpg'

export default function FaqsPage() {

  const faqsList = faqsArray?.map((faq, index) => {
    return <FaqItem
      key={index}
      question={faq.question}
      answer={faq.answer}
    />
  })

  return (
    <div className="faqs-page">
      <HelmetTitle title="FAQs" />
      <PageBanner
        title="FAQs"
        subtitle="Get the Information You Need: Our Comprehensive FAQ Section"
      />
      <div className="page-content">
        <SiteGrid className="faqs-section section">
          <div className="titles">
            <h5>FAQs</h5>
            <h2>General FAQs</h2>
            <p>
              Our FAQs page is designed to provide you with quick and easy
              answers to some of the most common questions we receive
              about our healthcare services.
            </p>
          </div>
          <div className="faqs-grid">
            <div className="img-container">
              <img src={faqsImg} alt="faqs" />
            </div>
            <div className="right">
              <div className="faqs-list">
                {faqsList}
              </div>
            </div>
          </div>
        </SiteGrid>
      </div>
    </div>
  )
}

export const FaqItem = ({ question, answer }) => {

  const [showAnswer, setShowAnswer] = useState(false)

  return <div className={`faq-item ${showAnswer ? 'open' : ''}`}>
    <div
      className="faq-question"
      onClick={() => setShowAnswer(prev => !prev)}
    >
      <h4>{question}</h4>
    </div>
    <div className={`faq-answer ${showAnswer ? 'show' : ''}`}>
      <p>{answer}</p>
    </div>
  </div>
}